import { QUESTIONS, NA_VALUE } from "../data/diagnosticQuestions";
import { API_BASE } from "./Constants";

function buildQuizAnswers(answers) {
    return QUESTIONS.map((q) => ({
        question_id: q.id,
        question_text: q.text_is,
        answer: answers[q.id] != null ? answers[q.id] : null,
    })).filter((a) => a.answer != null);
}

function countNaAnswers(answers) {
    return Object.values(answers).filter((a) => a === NA_VALUE).length;
}

export async function submitToCRM({ contact, result }) {
    const payload = {
        company_name: contact.company,
        contact_person: contact.name,
        contact_email: contact.email,
        quiz_score: result.quizScore,
        quiz_answers: buildQuizAnswers(result.answers),
        metadata: {
            source_url:
                typeof window !== "undefined" ? window.location.href : "",
            completed_at: new Date().toISOString(),
            recommended_package: result.recommendation,
            grunnstada: result.composite.grunnstada,
            thrystingur: result.composite.thrystingur,
            taekifaeri: result.composite.taekifaeri,
            category_scores: result.categoryScores,
            na_count: countNaAnswers(result.answers),
        },
    };

    const response = await fetch(`${API_BASE}/public/diagnostic-lead`, {
        method: "POST",
        headers: {
            accept: "application/json",
            "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
    });

    if (!response.ok) {
        console.error(`CRM submit failed: ${response.status}`);
        return { success: false };
    }

    const body = await response.json();
    return { success: true, leadId: body.results?.lead_id };
}
